import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Button, Collapse } from 'reactstrap';
import get from 'lodash/get';

import SpecialFormattedNumber from 'Containers/Utility/Price/SpecialFormattedNumber';
import PaymentIcon from 'Components/Payment/PaymentIcon';
import PaymentError from 'Components/Payment/PaymentError';
import CardPayment from 'Components/Payment/CardPayment';
import WalletPayment from 'Components/Payment/WalletPayment';
import ApplePayPayment from 'Components/Payment/ApplePayPayment';
import GooglePayPayment from 'Components/Payment/GooglePayPayment';
import WeChatPayment from 'Components/Payment/WeChatPayment';
import PayPalPayment from 'Components/Payment/PayPalPayment';
import PaymentContext from 'Components/Payment/payment-context';

export default function PaymentMethod({
  method,
  selected,
}) {
  const { selectMethod, currency, paymentError } = useContext(PaymentContext);
  const isCard = method.type === 'scheme';

  let Method;

  switch (method.type) {
    case 'scheme':
      Method = CardPayment;
      break;
    case 'applepay':
      Method = ApplePayPayment;
      break;
    case 'paypal':
      Method = PayPalPayment;
      break;
    case 'paywithgoogle':
      Method = GooglePayPayment;
      break;
    case 'wechatpayQR':
      Method = WeChatPayment;
      break;
    default:
      Method = WalletPayment;
  }

  const transactionFeeAmountPounds = get(method, 'configuration.transactionFee.amountPounds');
  const isOpen = !!selected;

  return (
    <div className={`payment-option-container payment-option-${method.type}`}>
      <Button
        className={classNames('payment-option', { cards: isCard })}
        onClick={() => selectMethod(method.type)}
      >
        <div className="left-container">
          <div className={classNames('option-circle', { selected: isOpen })}>
            {isOpen &&
              <div className="middle-circle" />
            }
          </div>
          <div className="payment-name-container">
            {isCard && window.locale === 'en' ? 'Card Payment' : method.name}

            {transactionFeeAmountPounds &&
              <span className="payment-name-fee ml-2">
                +
                <SpecialFormattedNumber
                  value={transactionFeeAmountPounds}
                  style="currency"
                  currency={currency}
                />
              </span>
            }
          </div>
        </div>
        <div className="right-container">
          <PaymentIcon name={method.name} type={method.type} brands={method.brands} />
        </div>
      </Button>

      <Collapse isOpen={isOpen}>
        <PaymentError pad error={paymentError} />
        <Method method={method} isOpen={isOpen} />
      </Collapse>
    </div>
  );
}

PaymentMethod.propTypes = {
  method: PropTypes.shape({}).isRequired,
  selected: PropTypes.bool,
};

PaymentMethod.defaultProps = {
  selected: false,
};
